import React, { useState, useEffect, useRef } from "react";
import { AgGridReact } from "ag-grid-react";
import { Card } from "antd";
import EmptyPlaceholder from "../../atoms/EmptyPlaceholder";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import "ag-grid-community/styles/ag-theme-alpine.css"; // or balham/material

const Grid = (props) => {
  const {
    defaultGridProps,
    filterGrid,
    data,
    columns,
    pagination,
    defaultSettings,
    noRowlabel,
    noRowbtnAction,
    refreshAction,
    fullPage,
    rowSelection,
    headerHeight,
    editType = "",
    onSelectionChanged,
    onCellValueChanged,
    suppressRowClickSelection = true,
    deselectAll,
    overlayNoRowsTemplate = "",
    autoSizeColumns,
    className,
    gridClassName = "",
    rowHeight,
    domLayout,
    maxHeight,
    height,
    onGridReady,
  } = props;

  const [gridApi, setGridApi] = useState(null);
  const [gridColumnApi, setGridColumnApi] = useState(null);
  const [rowData, setRowData] = useState([]);
  const [noRow, setNoRow] = useState(false);
  const gridRef: any = useRef();
  const isStateApplied = useRef(false);

  const autosize = () => {
    const columns = gridColumnApi?.getColumns();

    const allColumnIds = [];
    columns?.forEach((column) => {
      allColumnIds?.push(column?.colId);
    });
    gridColumnApi?.autoSizeColumns(allColumnIds, false);
  };

  useEffect(() => {
    if (data?.length > 0) {
      setRowData(data);

      data?.length ? setNoRow(false) : setNoRow(true);
    } else {
      setRowData(null);
    }
  }, [data]);

  useEffect(() => {
    if (autoSizeColumns && gridColumnApi && data?.length > 0) {
      setTimeout(() => {
        autosize();
      }, 300);
    }
  }, [gridColumnApi, data]);

  useEffect(() => {
    gridApi && gridApi.setQuickFilter(filterGrid);
  }, [filterGrid]);

  useEffect(() => {
    refreshAction ? refreshCells() : null;
  }, [refreshAction]);

  const refreshCells = () => {
    var params = {
      force: true,
      suppressFlash: true,
    };
    gridApi && gridApi.refreshCells(params);
  };

  useEffect(() => {
    gridApi?.deselectAll();
  }, [deselectAll]);

  function handleGridReady(params) {
    gridRef.current = params.columnApi;

    setGridApi(params.api);
    setGridColumnApi(params.columnApi);

    onGridReady?.(params);
  }

  // Save column state when columns are reordered or resized
  const onColumnStateChanged = () => {
    if (gridColumnApi) {
      const columnState = gridColumnApi.getColumnState();
      localStorage.setItem("ag-grid-column-state", JSON.stringify(columnState));
    }
  };

  return (
    <div className={`custom-style ${className}`}>
      <div
        id="myGrid"
        style={
          height
            ? { height: height, width: "100%", maxHeight: maxHeight }
            : { height: "215px", width: "100%", maxHeight: maxHeight }
        }
        className={`ag-theme-material ag-theme-alpine ${fullPage && data?.length ? "fp-height" : ""} ${
          noRow ? "h-auto" : ""
        }`}
      >
        <AgGridReact
          {...defaultGridProps}
          ref={gridRef}
          // autoSizeStrategy={autoSizeCell}
          defaultColDef={{ ...defaultSettings }}
          className={gridClassName}
          // colResizeDefault={"shift"}
          suppressMovableColumns={true}
          suppressDragLeaveHidesColumns={true}
          pagination={pagination}
          animateRows={true}
          columnDefs={columns}
          headerHeight={headerHeight}
          rowData={rowData}
          editType={editType}
          rowHeight={rowHeight}
          onColumnMoved={() => onColumnStateChanged()} // Column reordered
          // onColumnResized={onColumnStateChanged} // Column resized
          // onColumnPinned={onColumnStateChanged}  // Column pinned/unpinned
          rowSelection={rowSelection ? rowSelection : null}
          onGridReady={handleGridReady}
          onSelectionChanged={onSelectionChanged}
          onCellValueChanged={onCellValueChanged}
          suppressRowClickSelection={suppressRowClickSelection}
          overlayNoRowsTemplate={overlayNoRowsTemplate}
          enableBrowserTooltips={true}
          enableCellTextSelection={true} // Allows selection & copy
          suppressClipboardPaste={true}
        />
      </div>
      {noRow && overlayNoRowsTemplate === "" && (
        <Card bordered={false}>
          <EmptyPlaceholder label={noRowlabel} action={noRowbtnAction} />
        </Card>
      )}
    </div>
  );
};

export default Grid;
